export const pages = ['Dashboard', 'Application List', 'Settings']

export const settings = ['Profile', 'My account', 'Logout']
export const login = ['Login', 'Register']
